export enum AccidentLiabilty {
  INSURED_IS_RESPONSIBLE = 'INSURED_IS_RESPONSIBLE',
  OPPOSITE_PARTY_IS_RESPONSIBLE = 'OPPOSITE_PARTY_IS_RESPONSIBLE',
  BOTH_ARE_RESPONSIBLE = 'BOTH_ARE_RESPONSIBLE',
}

export enum AccidentType {
  ACCIDENT_OTHER_PARTIES_INVOLVED_ALL_KNOWN = 'ACCIDENT_OTHER_PARTIES_INVOLVED_ALL_KNOWN',
  ACCIDENT_OTHER_PARTIES_INVOLVED_SOME_KNOWN = 'ACCIDENT_OTHER_PARTIES_INVOLVED_SOME_KNOWN',
  ACCIDENT_NO_OTHER_PARTIES_INVOLVED = 'ACCIDENT_NO_OTHER_PARTIES_INVOLVED',
  GLASS_BREAKAGE = 'GLASS_BREAKAGE',
  VANDALISM = 'VANDALISM',
  THEFT = 'THEFT',
  BURGLARY = 'BURGLARY',
  RESPONDING_FIRE = 'RESPONDING_FIRE',
  BREAKDOWN = 'BREAKDOWN',
  NATURAL_DISASTER = 'NATURAL_DISASTER',
  OTHER = 'OTHER',
}